"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'Navbar',
  data: function data() {
    return {
      isShowFilterList: ['/search', '/classesListMsg', '/warningList'] //不显示筛选按钮页面
    };
  },
  computed: {
    pageTitle: function pageTitle() {
      return this.$route.meta.title;
    },
    transferTitle: function transferTitle() {
      var _this = this;
      var transferTitle = '';
      this.$bus.on('changePageTitle', function (title) {
        _this.$nextTick(function () {
          transferTitle = title;
        });
      });
      return transferTitle;
    }
  },
  methods: {
    onClickLeft: function onClickLeft() {
      this.$router.back(-1);
    },
    onClickRight: function onClickRight() {
      this.$emit('searchClick');
    }
  }
};